"use client"

import { TranslationValues, useTranslations } from "next-intl"
import { FC } from "react"

type DynamicTranslationProps = {
  tkey: string
  values?: TranslationValues
}

export const DynamicTranslation: FC<DynamicTranslationProps> = ({ tkey, values }) => {
  const t = useTranslations()

  // @ts-ignore -- next-intl dynamic vars in translation keys (https://github.com/amannn/next-intl/issues/103)
  return t(tkey, values)
}
